import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Route, useHistory } from "react-router-dom";
import Header from "../containers/header/header";
import useMedia from "../hooks/useMedia";
import { RoutesWrapper, StepsWrapper } from "./appLayoutStyles";
import PIWithStepsContext from "./PIWithStepsContext";
import CreditInfoWithStepsContext from "./creditInfoWithStepsContext";
import useServiceType from "../hooks/useServiseType";
import Callback from "../components/common/callback/callback";
import { SERVICE_TYPES } from "../utils/constants/fieldErrors";
import ContactInfoChangeWithStepsContext from "./ContactInfoChangeWithStepsContext";
import IbRegistrationWithStepsContext from "../layout/ibRegistrationWithStepsContext";
import IBservicechangeWithStepsContext from "../layout/IBservicechangeWithStepsContext";
import KYCformWithStepsContext from "../layout/KYCformWithStepsContext";
import LegalFormWithStepsContext from "../layout/LegalFormWithStepsContext";
import IdentificationWithStepsContext from "./IdentificationWithStepsContext";

const AppRoutes = () => {
  const [mobileNav, setShowMobNav] = useState(false);

  const isTablet = useMedia("(min-width: 768px)");
  const pathname = useHistory().location.pathname;
  const { i18n } = useTranslation();
  const { serviceType } = useServiceType();

  useEffect(() => {
    if (window.innerWidth < 768 || isTablet) {
      setShowMobNav(false);
    }
  }, [pathname, isTablet]);

  // Set language in localstorage
  useEffect(() => {
    if (i18n.language) {
      localStorage.setItem("culture", i18n.language);
    }
  });

  return (
    <RoutesWrapper>
      <div className={`agreement ${mobileNav ? " opened" : ""}`}>
        <StepsWrapper>
          <Header />
          <Route component={Callback} path={`/callback/:id`} />

          {serviceType === SERVICE_TYPES.PIForm && <PIWithStepsContext />}
          {serviceType === SERVICE_TYPES.ibRegistration && (
            <IbRegistrationWithStepsContext />
          )}
          {serviceType === SERVICE_TYPES.creditInfoForm && (
            <CreditInfoWithStepsContext />
          )}
          {serviceType === SERVICE_TYPES.ContactInfoChangeForm && (
            <ContactInfoChangeWithStepsContext />
          )}
          {serviceType === SERVICE_TYPES.IBservicechange && (
            <IBservicechangeWithStepsContext />
          )}
          {serviceType === SERVICE_TYPES.KYCform && <KYCformWithStepsContext />}
          {serviceType === SERVICE_TYPES.Legal && <LegalFormWithStepsContext />}
          {serviceType === SERVICE_TYPES.identification && (
            <IdentificationWithStepsContext />
          )}
        </StepsWrapper>
      </div>
    </RoutesWrapper>
  );
};

export default AppRoutes;
